/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');

var PlaceholderView = require('common/views/PlaceholderView');

var SecComplianceAGReferralSectionView = require('../views/SecComplianceAGReferralSectionView');
var GetComplianceAGReferralPaymentsByCompliance = require('../services/GetComplianceAGReferralPaymentsByCompliance');

module.exports = {
  channel: 'sc',

  event: 'build:comp-ag-referral-view',

  builder: function(complianceId) {
    return new PlaceholderView({
      viewPromise: buildComplianceAGReferralView(complianceId)
    });
  }
};

function buildComplianceAGReferralView(complianceId) {
  var deferred = $.Deferred();
  GetComplianceAGReferralPaymentsByCompliance(complianceId)
    .done(function(AGReferral) {
      deferred.resolve(
        new SecComplianceAGReferralSectionView({
          model: new Backbone.Model(AGReferral)
        })
      );
    })
    .fail(function(err) {
      deferred.reject(err);
    });
  return deferred.promise();
}
